export default "__VITE_ASSET__DIQZGxYn__"